import { Box, IconButton, InputLabel, TextField } from "@mui/material"
import Icons from "../../assets/js/Icons"
import { useState } from "react"
import { uid } from "uid"

function InputFieldB({
  id,
  name,
  type,
  label,
  error,
  success,
  variant,
  inputtype,
  helperText,
  placeholder,
  labelvariant,
  ...rest
}) {
  id = id || uid(6)
  const [show, setShow] = useState(false)

  return (
    <Box>
      {label &&
        <InputLabel
          htmlFor={id}
          labelvariant={labelvariant || "InputFieldB"}
        >{label}
        </InputLabel>
      }
      <TextField
        fullWidth
        size="small"
        name={name || null}
        inputtype={inputtype || null}
        variant={variant || "standard"}
        multiline={type === "textarea"}
        placeholder={placeholder || null}
        error={Boolean(helperText?.[name]) || null}
        helperText={helperText?.[name]?.[0] || null}
        type={
          (type === "password" ? show ? "text" : "password"
            : type) || "text"
        }
        slotProps={{
          input: {
            id,
            rows: 5,
            autoComplete: "new-password",
            endAdornment:
              type === "password" ?
                (<IconButton
                  size="small"
                  sx={{ p: "2px" }}
                  onClick={() => { setShow(!show) }}
                >{!show ? <Icons.ViewSolid /> : <Icons.ViewOffSolid />}
                </IconButton>
                ) : null
          }
        }}
        {...rest}
      />
    </Box>
  )
}

export default InputFieldB